import React from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import WorkIcon from '@mui/icons-material/Work'
import Divider from '@mui/material/Divider'
import DescriptionIcon from '@mui/icons-material/Description'
import StorefrontIcon from '@mui/icons-material/Storefront'
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark'
import { usePosition } from '../../context'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 400
    },
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    }
  })
)

interface ViewPositionProps {}

export const ViewPosition: React.FC<ViewPositionProps> = () => {
  const { state } = usePosition()
  const { rows, idForDelete } = state

  const elemento = rows.filter((item) => item.id === idForDelete)[0]

  const classes = useStyles()
  return (
    <Grid container direction='row' spacing={2}>
      <Grid item xs={12} md={6}>
        <List className={classes.root}>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <BrandingWatermarkIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Nombre Posición'
              secondary={elemento.positionName}
            />
          </ListItem>
          <Divider variant='inset' component='li' />{' '}
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <StorefrontIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary='Zona' secondary={elemento.zone.zoneName} />
          </ListItem>
          <Divider variant='inset' component='li' />
        </List>
      </Grid>
      <Grid item xs={12} md={6}>
        <List>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <WorkIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Código Posición'
              secondary={elemento.positionCode}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <StorefrontIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='SubZona'
              secondary={elemento.subZone.subZoneName}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
        </List>
      </Grid>

      <Grid item xs={12} md={6}>
        <List>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <CheckBoxIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Activo'
              secondary={elemento.active ? 'Si' : 'No'}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
        </List>
      </Grid>

      <Grid item xs={12}>
        <List>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <DescriptionIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Descripción Posición'
              secondary={elemento.positionDescription}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
        </List>
      </Grid>
    </Grid>
  )
}
